module.exports = __webpack_public_path__ + "chrome.9f6c1286b965db70e9d9bd561d93d9fd.jpg";